// SOFIA screen help (the "?" at the top of SOFIA, on the list and on a project). Plain
// words; keep it in step with the screen in tools/SofiaTool.tsx.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const sofiaHelp: ScreenHelpContent = {
  title: 'SOFIA',
  intro:
    'SOFIA holds your REACH projects. A REACH project is a way to learn about anything, in five steps: look into it, judge what you found, spot patterns, add something of your own, and note what you will do differently next time.',
  sections: [
    {
      heading: 'Your list of projects',
      body: [
        'Type a title into "New REACH project title…" and press Add. The new project opens straight away. Recently changed projects come first.',
        'Each card shows the title and how far along it is: "Not started", a count like "2/5 steps filled", or "All steps filled". A project with no title shows as "Untitled Reach".',
      ],
    },
    {
      heading: 'The dot on each card',
      body: ['The dot shows whether a project is active. Green is active, grey is inactive. Tap the dot to switch it.'],
    },
    {
      heading: 'Open, switch or delete',
      body: [
        'Tap a card to open it.',
        'Press and hold a card for a menu: Set Inactive (or Set Active), or Delete. Delete asks you to confirm first.',
      ],
    },
    {
      heading: 'Inside a project: the five boxes',
      body: ['Each box has a short prompt in italics. Write your answer in the box below it.'],
      items: [
        { term: 'Research', text: 'what do I need to learn or find out about…' },
        { term: 'Evaluation', text: 'what I thought of what I found was…' },
        { term: 'Analysis', text: 'the patterns and insights I see are…' },
        { term: 'Contribution', text: 'what I am adding or building on top is…' },
        { term: 'Hindsight', text: 'next time I know…' },
      ],
    },
    {
      heading: 'Inside a project: Steps',
      body: [
        'A to-do list for this project. Press + Add Step for a new line, type what to do, and tick the box when it is done. Press × to remove a line (the last line cannot be removed).',
        'The title at the top is editable too. Press ‹ Back to return to the list.',
      ],
    },
    {
      heading: 'Task',
      body: ['At the bottom, a note says whether a task list is linked to this project. You can\'t link one here; that is done from the web app.'],
    },
    {
      heading: 'Saving',
      body: ['There is no Save button. Your writing saves by itself a moment after you stop typing, and a small spinner shows while it saves. Turning a project active or inactive saves straight away.'],
    },
  ],
};
